import { Trans } from '@lingui/react/macro';

import { ActivityOfType } from '@/components/activities/Activity';
import {
  BaseActivity,
  BaseActivityArticleName,
  BaseActivityDetailedContent,
  BaseActivityText,
} from '@/components/activities/BaseActivity/BaseActivity';
import IconCancel from '@/icons/Cancel.svg';

export const ArticleExchangeCancelledActivity = ({
  activity,
  displayArticleName,
}: {
  activity: ActivityOfType<'article_exchange_cancelled'>;
  displayArticleName: boolean;
}) => {
  const workshopName = activity.entity.name;
  const creatorName = activity.creator?.name;

  const articleName = (
    <BaseActivityArticleName activity={activity} displayArticleName={displayArticleName} />
  );

  return (
    <BaseActivity
      createdAt={activity.createdAt}
      type="danger"
      icon={<IconCancel />}
      message={
        <BaseActivityText>
          {activity.data.onBehalfOfWorkshop ? (
            <Trans id="activities.article_exchange_cancelled.message.on-behalf">
              <strong>{creatorName}</strong> cancelled the exchange of the item {articleName} on
              behalf of <strong>{workshopName}</strong>
            </Trans>
          ) : (
            <Trans id="activities.article_exchange_cancelled.message">
              <strong>{creatorName}</strong> cancelled the exchange of the item {articleName}
            </Trans>
          )}
        </BaseActivityText>
      }
    >
      {!!activity.data.comment && (
        <BaseActivityDetailedContent>{activity.data.comment}</BaseActivityDetailedContent>
      )}
    </BaseActivity>
  );
};
